import React from "react";
import Breakpoint from "./Breakpoint";
const DesktopBreakPoint = (props) => {
    
  return <Breakpoint name="desktop">{props.children}</Breakpoint>;
};

export default DesktopBreakPoint;
